export default __webpack_public_path__ + "static/partnerstodaylogo-c58e9082fc41e612951cec7243d6c11a.svg";